import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Decode_Error from "../Data.Argonaut.Decode.Error/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Bounded from "../Data.Bounded/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function_Uncurried from "../Data.Function.Uncurried/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_LoadDirection from "../Data.LoadDirection/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Nullable from "../Data.Nullable/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Profunctor from "../Data.Profunctor/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_AVar from "../Effect.AVar/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Aff_AVar from "../Effect.Aff.AVar/index.js";
import * as Effect_Aff_Class from "../Effect.Aff.Class/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Fusion_Data_Bytes from "../Fusion.Data.Bytes/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_FSErrorPart from "../Fusion.Data.FSErrorPart/index.js";
import * as Fusion_Data_ObservableEvent from "../Fusion.Data.ObservableEvent/index.js";
import * as Fusion_EngineV2 from "../Fusion.EngineV2/index.js";
import * as Fusion_Foreign_Data_NQError from "../Fusion.Foreign.Data.NQError/index.js";
import * as Fusion_Foreign_Data_NQValue from "../Fusion.Foreign.Data.NQValue/index.js";
import * as Fusion_Foreign_JsSDK from "../Fusion.Foreign.JsSDK/index.js";
import * as Fusion_Foreign_Rx from "../Fusion.Foreign.Rx/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_Impl_AppM from "../Fusion.Impl.AppM/index.js";
import * as Fusion_LoadFinal from "../Fusion.LoadFinal/index.js";
import * as Fusion_LoadOutput from "../Fusion.LoadOutput/index.js";
import * as Fusion_StreamConfig from "../Fusion.StreamConfig/index.js";
import * as Fusion_Streamers_UploadXHR from "../Fusion.Streamers.UploadXHR/index.js";
import * as Fusion_Types from "../Fusion.Types/index.js";
import * as Fusion_Util from "../Fusion.Util/index.js";
import * as Halogen_VDom_Driver from "../Halogen.VDom.Driver/index.js";
import * as MST_Data_BasicURL from "../MST.Data.BasicURL/index.js";
import * as Streamers_DownloadFetch from "../Streamers.DownloadFetch/index.js";
import * as Visonum_Cross_Components_App_HandleAction from "../Visonum.Cross.Components.App.HandleAction/index.js";
import * as Visonum_Cross_Components_App_Types_AppState from "../Visonum.Cross.Components.App.Types.AppState/index.js";
import * as Visonum_Cross_Components_StandaloneChart from "../Visonum.Cross.Components.StandaloneChart/index.js";
import * as Visonum_Cross_Embed from "../Visonum.Cross.Embed/index.js";
import * as Visonum_Cross_Types_Brand_Visonum from "../Visonum.Cross.Types.Brand.Visonum/index.js";
import * as Visonum_Cross_Views_Chart from "../Visonum.Cross.Views.Chart/index.js";
import * as Visonum_Cross_Views_Chart_Configs from "../Visonum.Cross.Views.Chart.Configs/index.js";
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect_Aff.applicativeAff);
var kill = /* #__PURE__ */ Control_Monad_Fork_Class.kill(Control_Monad_Fork_Class.monadKillAff);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect_Aff.applicativeAff)(Data_Foldable.foldableMaybe);
var upcast = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberModemDE);
var map = /* #__PURE__ */ Data_Functor.map(Data_Maybe.functorMaybe);
var upcast1 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberDownloadInte);
var upcast2 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberUploadInterm);
var upcast3 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberWarningDE);
var upcast4 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberDownloadFina);
var upcast5 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberUploadFinalD);
var liftEitherErr = /* #__PURE__ */ Fusion_Util.liftEitherErr(Control_Monad_Error_Class.monadErrorEffect);
var decodeJson = /* #__PURE__ */ Data_Argonaut_Decode_Class.decodeJson(Fusion_LoadOutput.decodeJsonLoadOutput);
var upcast6 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberFusionDownlo);
var encodeJson = /* #__PURE__ */ Data_Argonaut_Encode_Class.encodeJson(Fusion_LoadOutput.encodeJsonLoadOutput);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var fromJsonDecodeError2 = /* #__PURE__ */ Fusion_Data_FSErrorPart.fromJsonDecodeError2(Fusion_Foreign_Data_NQValue.nQValueMemberPrepareResul);
var upcast7 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberBenchmarkDE);
var stripStatsUrls = /* #__PURE__ */ Fusion_LoadFinal.stripStatsUrls(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var addSpeedtestIdParam = /* #__PURE__ */ Fusion_LoadFinal.addSpeedtestIdParam(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var addDisableCorsParam = /* #__PURE__ */ Fusion_LoadFinal.addDisableCorsParam(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Data_Array_NonEmpty_Internal.applicativeNonEmptyArray);
var nub = /* #__PURE__ */ Data_Array_NonEmpty.nub(MST_Data_BasicURL.ordBasicURL);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var length = /* #__PURE__ */ Data_Foldable.length(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Semiring.semiringInt);
var top = /* #__PURE__ */ Data_Bounded.top(Data_Bounded.boundedInt);
var min = /* #__PURE__ */ Data_Ord.min(Data_Ord.ordInt);
var isFinalEither = /* #__PURE__ */ Fusion_Generator.isFinalEither(Fusion_LoadOutput.isFinalLoadOutput);
var upcast8 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberPingDE);
var upcast9 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberCompleteDE);
var upcast10 = /* #__PURE__ */ Fusion_Foreign_Data_NQValue.upcast(Fusion_Foreign_Data_NQValue.nQValueMemberPrepareResul);
var lcmap = /* #__PURE__ */ Data_Profunctor.lcmap(Data_Profunctor.profunctorFn);
var bimap = /* #__PURE__ */ Data_Bifunctor.bimap(Data_Bifunctor.bifunctorEither);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var show = /* #__PURE__ */ Data_Show.show(Data_Argonaut_Decode_Error.showJsonDecodeError);
var mkEngineV2Interface = /* #__PURE__ */ Fusion_EngineV2.mkEngineV2Interface(Fusion_Impl_AppM.monadAppFSErrorAppMFSErro);
var liftAff = /* #__PURE__ */ Effect_Aff_Class.liftAff(/* #__PURE__ */ Effect_Aff_Class.monadAffExceptT(Effect_Aff_Class.monadAffAff));
var updateLoadResultDownload = /* #__PURE__ */ Data_Function_Uncurried.mkFn2(Visonum_Cross_Components_App_HandleAction.updateLoadResult);
var standaloneChartHandle = function (v) {
    var av = Effect_AVar.empty();
    var ref = Effect_Ref["new"](Data_Maybe.Nothing.value)();
    var fib = Effect_Aff.launchAff(bind1(Halogen_VDom_Driver.runUI(Visonum_Cross_Components_StandaloneChart.component)({})(v.element))(function (io) {
        return discard1(Effect_Aff_AVar.put(io.dispose)(av))(function () {
            return discard1(liftEffect(Effect_Ref.write(new Data_Maybe.Just(io.query))(ref)))(function () {
                return pure({});
            });
        });
    }))();
    return {
        canceller: Effect_Aff.launchAff_(bind1(Effect_Aff_AVar.take(av))(function (dispose) {
            return discard1(dispose)(function () {
                return kill(Fusion_Generator.cancellationException)(fib);
            });
        })),
        updateProps: function (props) {
            var maybeFn = Effect_Ref.read(ref)();
            return Effect_Aff.launchAff_(for_(maybeFn)(function (fn) {
                return fn(new Visonum_Cross_Components_StandaloneChart.TellNewProps(props, Data_Unit.unit));
            }))();
        }
    };
};
var phase2 = function (dictMonadApp) {
    var bracket = Control_Monad_Fork_Class.bracket(dictMonadApp.MonadBracket2());
    var reEmit = Fusion_Generator.reEmit((dictMonadApp.MonadAppNE4()).MonadRec1())((dictMonadApp.MonadKill3()).MonadThrow1());
    return function (sdk) {
        return function (prepareResult) {
            return function (emit) {
                return bracket(sdk.modem(prepareResult))(function (v) {
                    return function (modemGen) {
                        return Fusion_Generator.cancel(modemGen);
                    };
                })(function (modemGen) {
                    return reEmit(modemGen)(function ($185) {
                        return emit(Data_Either.Right.create(upcast($185)));
                    });
                });
            };
        };
    };
};
var mkChartPropsDownload = function (v) {
    return Visonum_Cross_Views_Chart_Configs.velocityDownloadConfig({
        appMode: Visonum_Cross_Components_App_Types_AppState.NormalMode.value,
        theme: Visonum_Cross_Types_Brand_Visonum.themeVelocityUI,
        loadResult: v.loadResult,
        embedOpts: Visonum_Cross_Embed.velocityEmbedOpts,
        bookedSpeedMax: map(Visonum_Cross_Views_Chart.Y)(Data_Nullable.toMaybe(v.bookedSpeedMax))
    });
};
var loadOutputToNqValue = function (loadDirection) {
    return function (loadOutput) {
        if (loadOutput instanceof Fusion_LoadOutput.Current) {
            return Data_Maybe.Nothing.value;
        };
        if (loadOutput instanceof Fusion_LoadOutput.TotalIntermediate) {
            var v = {
                speed: loadOutput.value0.speed
            };
            if (loadDirection instanceof Data_LoadDirection.Download) {
                return new Data_Maybe.Just(upcast1(Fusion_Foreign_Data_NQValue.toDownloadIntermediateDE(v)));
            };
            if (loadDirection instanceof Data_LoadDirection.Upload) {
                return new Data_Maybe.Just(upcast2(Fusion_Foreign_Data_NQValue.toUploadIntermediateDE(v)));
            };
            throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 320, column 9 - line 324, column 69): " + [ loadDirection.constructor.name ]);
        };
        if (loadOutput instanceof Fusion_LoadOutput.StreamIntermediate) {
            return Data_Maybe.Nothing.value;
        };
        if (loadOutput instanceof Fusion_LoadOutput.IntermediateStatsPassive) {
            return Data_Maybe.Nothing.value;
        };
        if (loadOutput instanceof Fusion_LoadOutput.IntermediateStatsActive) {
            return Data_Maybe.Nothing.value;
        };
        if (loadOutput instanceof Fusion_LoadOutput.ServerSideLoadedBytes) {
            return Data_Maybe.Nothing.value;
        };
        if (loadOutput instanceof Fusion_LoadOutput.ServerSideStreamIntermediate) {
            return Data_Maybe.Nothing.value;
        };
        if (loadOutput instanceof Fusion_LoadOutput.ServerSideTotalIntermediate) {
            return Data_Maybe.Nothing.value;
        };
        if (loadOutput instanceof Fusion_LoadOutput.Warning) {
            return new Data_Maybe.Just(upcast3(Fusion_Foreign_Data_NQValue.toWarningDE(loadOutput.value0.warning)));
        };
        if (loadOutput instanceof Fusion_LoadOutput.Final) {
            var v = {
                speed: loadOutput.value0.speed,
                jitter: loadOutput.value0.jitter
            };
            if (loadDirection instanceof Data_LoadDirection.Download) {
                return new Data_Maybe.Just(upcast4(Fusion_Foreign_Data_NQValue.toDownloadFinalDE(v)));
            };
            if (loadDirection instanceof Data_LoadDirection.Upload) {
                return new Data_Maybe.Just(upcast5(Fusion_Foreign_Data_NQValue.toUploadFinalDE(v)));
            };
            throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 345, column 9 - line 349, column 62): " + [ loadDirection.constructor.name ]);
        };
        throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 313, column 3 - line 349, column 62): " + [ loadOutput.constructor.name ]);
    };
};
var loadOutputDecodeJson = function (json) {
    return liftEitherErr(function ($186) {
        return Effect_Exception.error(Data_Argonaut_Decode_Error.printJsonDecodeError($186));
    })(decodeJson(json))();
};
var emitLoadOutputFusion = function (dictMonadApp) {
    var throwError = Control_Monad_Error_Class.throwError((dictMonadApp.MonadKill3()).MonadThrow1());
    var pure3 = Control_Applicative.pure(((dictMonadApp.MonadWebsockets5()).Monad0()).Applicative0());
    return function (loadDirection) {
        return function (emit) {
            return function (eLoadOutput) {
                if (loadDirection instanceof Data_LoadDirection.Download) {
                    if (eLoadOutput instanceof Data_Either.Left) {
                        return throwError(eLoadOutput.value0);
                    };
                    if (eLoadOutput instanceof Data_Either.Right) {
                        if (eLoadOutput instanceof Data_Either.Right) {
                            return emit(upcast6(Fusion_Foreign_Data_NQValue.toFusionDownloadOutputDE({
                                loadOutput: encodeJson(eLoadOutput.value0)
                            })));
                        };
                        if (eLoadOutput instanceof Data_Either.Left) {
                            return throwError(eLoadOutput.value0);
                        };
                        throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 291, column 21 - line 293, column 37): " + [ eLoadOutput.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 289, column 7 - line 293, column 37): " + [ eLoadOutput.constructor.name ]);
                };
                if (loadDirection instanceof Data_LoadDirection.Upload) {
                    return pure3(Data_Unit.unit);
                };
                throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 287, column 3 - line 294, column 24): " + [ loadDirection.constructor.name ]);
            };
        };
    };
};
var emitLoadOutput = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var discard2 = discard(Monad0.Bind1());
    var emitLoadOutputFusion1 = emitLoadOutputFusion(dictMonadApp);
    var throwError = Control_Monad_Error_Class.throwError((dictMonadApp.MonadKill3()).MonadThrow1());
    var pure3 = Control_Applicative.pure(Monad0.Applicative0());
    return function (loadDirection) {
        return function (emit) {
            return function (eLoadOutput) {
                return discard2(emitLoadOutputFusion1(loadDirection)(emit)(eLoadOutput))(function () {
                    if (eLoadOutput instanceof Data_Either.Left) {
                        return throwError(eLoadOutput.value0);
                    };
                    if (eLoadOutput instanceof Data_Either.Right) {
                        var v1 = loadOutputToNqValue(loadDirection)(eLoadOutput.value0);
                        if (v1 instanceof Data_Maybe.Just) {
                            return emit(v1.value0);
                        };
                        if (v1 instanceof Data_Maybe.Nothing) {
                            return pure3(Data_Unit.unit);
                        };
                        throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 307, column 16 - line 309, column 27): " + [ v1.constructor.name ]);
                    };
                    throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 305, column 3 - line 309, column 27): " + [ eLoadOutput.constructor.name ]);
                });
            };
        };
    };
};
var phase1 = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var MonadThrow1 = (dictMonadApp.MonadKill3()).MonadThrow1();
    var liftEither = Control_Monad_Error_Class.liftEither(MonadThrow1);
    var discard2 = discard(Bind1);
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    var reEmit = Fusion_Generator.reEmit((dictMonadApp.MonadAppNE4()).MonadRec1())(MonadThrow1);
    var downloadMock = Fusion_LoadFinal.downloadMock(dictMonadApp);
    var loadFinal = Fusion_LoadFinal.loadFinal(dictMonadApp);
    var calcDownload = Fusion_LoadFinal.calcDownload(dictMonadApp);
    var reEmitF = Fusion_Generator.reEmitF(Monad0)(isFinalEither)(MonadBracket2);
    var emitLoadOutput1 = emitLoadOutput(dictMonadApp);
    var uploadMock = Fusion_LoadFinal.uploadMock(dictMonadApp);
    var calcUpload = Fusion_LoadFinal.calcUpload(dictMonadApp);
    return function (sdk) {
        return function (engineItf) {
            return function (options) {
                return function (fusionOptions) {
                    return function (prepareResult) {
                        return function (emit) {
                            return bind2(liftEither(lmap(fromJsonDecodeError2(Fusion_Data_FSError.ApRe01.value)(prepareResult))(Fusion_Foreign_Data_NQValue.decodeFSPrepareResult(prepareResult))))(function (v) {
                                return discard2(bracket(sdk.benchmark(prepareResult))(function (v1) {
                                    return function (benchmarkGen) {
                                        return Fusion_Generator.cancel(benchmarkGen);
                                    };
                                })(function (benchmarkGen) {
                                    return reEmit(benchmarkGen)(function ($187) {
                                        return emit(upcast7($187));
                                    });
                                }))(function () {
                                    var downloadAddresses = stripStatsUrls(fusionOptions.enableTcpStats)(addSpeedtestIdParam(v.info.speedtestID)(addDisableCorsParam((function () {
                                        if (fusionOptions.downloadUrls instanceof Fusion_Types.TakeFromPrepareResult) {
                                            return v.stepDetails.download.downloadAddresses;
                                        };
                                        if (fusionOptions.downloadUrls instanceof Fusion_Types.Value) {
                                            return fusionOptions.downloadUrls.value0;
                                        };
                                        throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 177, column 7 - line 179, column 27): " + [ fusionOptions.downloadUrls.constructor.name ]);
                                    })())));
                                    var uploadAddresses = stripStatsUrls(fusionOptions.enableTcpStats)(addSpeedtestIdParam(v.info.speedtestID)(addDisableCorsParam((function () {
                                        if (fusionOptions.uploadUrls instanceof Fusion_Types.TakeFromPrepareResult) {
                                            return pure2(v.stepDetails.upload.uploadAddress);
                                        };
                                        if (fusionOptions.uploadUrls instanceof Fusion_Types.Value) {
                                            return fusionOptions.uploadUrls.value0;
                                        };
                                        throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 186, column 7 - line 188, column 27): " + [ fusionOptions.uploadUrls.constructor.name ]);
                                    })())));
                                    var maxDownloadStreams = (function () {
                                        if (fusionOptions.enableTcpStats) {
                                            var uniqUrls = nub(map1(function (v1) {
                                                return v1.load;
                                            })(downloadAddresses));
                                            return length(uniqUrls) * 5 | 0;
                                        };
                                        return top;
                                    })();
                                    var maxUploadStreams = (function () {
                                        if (fusionOptions.enableTcpStats) {
                                            var uniqUrls = nub(map1(function (v1) {
                                                return v1.load;
                                            })(uploadAddresses));
                                            return length(uniqUrls) * 5 | 0;
                                        };
                                        return top;
                                    })();
                                    var uploadOptions = Fusion_StreamConfig.getUploadStreamConfig(v);
                                    return discard2(bracket(engineItf.connectToEngine)(function (v1) {
                                        return function (engineConnection) {
                                            return engineConnection.cancel;
                                        };
                                    })(function (engineConnection) {
                                        return discard2(bracket((function () {
                                            if (options.downloadMockData instanceof Data_Maybe.Just) {
                                                return downloadMock(options.downloadMockData.value0);
                                            };
                                            if (options.downloadMockData instanceof Data_Maybe.Nothing) {
                                                return loadFinal({
                                                    calcLoad: calcDownload(sdk),
                                                    engineConnection: engineConnection.connection
                                                })(Data_LoadDirection.DownloadP.value)(v.info.speedtestID)({
                                                    urls: downloadAddresses,
                                                    countStreams: min(maxDownloadStreams)(v.stepDetails.download.numStreams),
                                                    duration: (function () {
                                                        if (fusionOptions.downloadDuration instanceof Fusion_Types.TakeFromPrepareResult) {
                                                            return v.stepDetails.download.duration;
                                                        };
                                                        if (fusionOptions.downloadDuration instanceof Fusion_Types.Value) {
                                                            return fusionOptions.downloadDuration.value0;
                                                        };
                                                        throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 235, column 21 - line 237, column 49): " + [ fusionOptions.downloadDuration.constructor.name ]);
                                                    })()
                                                });
                                            };
                                            throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 222, column 11 - line 238, column 18): " + [ options.downloadMockData.constructor.name ]);
                                        })())(function (v1) {
                                            return function (genDownload) {
                                                return Fusion_Generator.cancel(genDownload);
                                            };
                                        })(function (genDownload) {
                                            return reEmitF(genDownload)(emitLoadOutput1(Data_LoadDirection.Download.value)(emit));
                                        }))(function () {
                                            return bracket((function () {
                                                if (options.uploadMockData instanceof Data_Maybe.Just) {
                                                    return uploadMock(options.uploadMockData.value0);
                                                };
                                                if (options.uploadMockData instanceof Data_Maybe.Nothing) {
                                                    return loadFinal({
                                                        calcLoad: calcUpload(sdk),
                                                        engineConnection: engineConnection.connection
                                                    })(new Data_LoadDirection.UploadP({
                                                        byteCount: uploadOptions.uploadByteCount
                                                    }))(v.info.speedtestID)({
                                                        urls: uploadAddresses,
                                                        countStreams: min(maxUploadStreams)(uploadOptions.uploadNumStreams),
                                                        duration: (function () {
                                                            if (fusionOptions.uploadDuration instanceof Fusion_Types.TakeFromPrepareResult) {
                                                                return v.stepDetails.upload.duration;
                                                            };
                                                            if (fusionOptions.uploadDuration instanceof Fusion_Types.Value) {
                                                                return fusionOptions.uploadDuration.value0;
                                                            };
                                                            throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 260, column 19 - line 262, column 47): " + [ fusionOptions.uploadDuration.constructor.name ]);
                                                        })()
                                                    });
                                                };
                                                throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 248, column 11 - line 263, column 16): " + [ options.uploadMockData.constructor.name ]);
                                            })())(function (v1) {
                                                return function (genUpload) {
                                                    return Fusion_Generator.cancel(genUpload);
                                                };
                                            })(function (genUpload) {
                                                return reEmitF(genUpload)(emitLoadOutput1(Data_LoadDirection.Upload.value)(emit));
                                            });
                                        });
                                    }))(function () {
                                        return discard2(bracket(sdk.ping(prepareResult))(function (v1) {
                                            return function (pingGen) {
                                                return Fusion_Generator.cancel(pingGen);
                                            };
                                        })(function (pingGen) {
                                            return reEmit(pingGen)(function ($188) {
                                                return emit(upcast8($188));
                                            });
                                        }))(function () {
                                            return bind2(sdk.complete(prepareResult))(function (completeResult) {
                                                return emit(upcast9(completeResult));
                                            });
                                        });
                                    });
                                });
                            });
                        };
                    };
                };
            };
        };
    };
};
var velocityUICore = function (dictMonadApp) {
    var Bind1 = ((dictMonadApp.MonadWebsockets5()).Monad0()).Bind1();
    var bind2 = Control_Bind.bind(Bind1);
    var discard2 = discard(Bind1);
    var phase11 = phase1(dictMonadApp);
    var phase21 = phase2(dictMonadApp);
    var catchError = Control_Monad_Error_Class.catchError((dictMonadApp.MonadBracket2()).MonadError1());
    return function (sdk) {
        return function (engineItf) {
            return function (options) {
                return function (fusionOptions) {
                    return function (emit) {
                        var phases = bind2(sdk.prepare(Fusion_Foreign_JsSDK.defaultPrepareOptions))(function (prepareResult) {
                            return discard2(emit(new Data_Either.Right(upcast10(prepareResult))))(function () {
                                return discard2(phase11(sdk)(engineItf)(options)(fusionOptions)(prepareResult)(function ($189) {
                                    return emit(Data_Either.Right.create($189));
                                }))(function () {
                                    return phase21(sdk)(prepareResult)(emit);
                                });
                            });
                        });
                        return catchError(phases)(function (err) {
                            return emit(new Data_Either.Left(err));
                        });
                    };
                };
            };
        };
    };
};

//---------------------------------------------------------------------------------------------
var velocityUI = function (dictMonadApp) {
    var velocityUICore1 = velocityUICore(dictMonadApp);
    return function (sdk) {
        return function (engineItf) {
            return function (rawOptions) {
                return function (emit) {
                    var convertEmit = lcmap(bimap(Fusion_Foreign_Data_NQError.toNQError)(identity));
                    var v = Fusion_Foreign_Data_NQValue.decodeFSSpeedtestOptions(rawOptions);
                    if (v instanceof Data_Either.Left) {
                        return emit(new Data_Either.Left(Fusion_Foreign_Data_NQError.toNQError(Fusion_Data_FSError.mk(Fusion_Data_FSError.Cl63.value)("Error decoding SpeedtestOptions: " + show(v.value0)))));
                    };
                    if (v instanceof Data_Either.Right) {
                        var fusionOptions = {
                            enableTcpStats: true,
                            downloadUrls: Fusion_Types.TakeFromPrepareResult.value,
                            uploadUrls: Fusion_Types.TakeFromPrepareResult.value,
                            pingUrl: Fusion_Types.TakeFromPrepareResult.value,
                            downloadDuration: Fusion_Types.TakeFromPrepareResult.value,
                            uploadDuration: Fusion_Types.TakeFromPrepareResult.value,
                            pingDuration: Fusion_Data_Duration.fromMs(10000.0),
                            uploadNumStreams: 1,
                            downloadNumStreams: 5,
                            uploadByteCount: Fusion_Data_Bytes.fromInt(5000000)
                        };
                        return velocityUICore1(sdk)(engineItf)(v.value0)(fusionOptions)(convertEmit(emit));
                    };
                    throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 109, column 5 - line 126, column 87): " + [ v.constructor.name ]);
                };
            };
        };
    };
};
var velocityUI1 = /* #__PURE__ */ velocityUI(Fusion_Impl_AppM.monadAppFSErrorAppMFSErro);
var speedtestCurried = function (jsSdk) {
    return function (rawOptions) {
        return Fusion_Foreign_Rx.mkObservableAff(function (emit) {
            var sdkAff = Fusion_Impl_AppM.mkJsSDKInterfaceProd(jsSdk);
            var engineInterfaceV2 = mkEngineV2Interface({
                mkUploadStreamer: function (byteCount) {
                    return function (url) {
                        return Fusion_Streamers_UploadXHR.xhrUploadStreamer({
                            url: url,
                            byteCount: byteCount
                        });
                    };
                },
                mkDownloadStreamer: Streamers_DownloadFetch.fetchDownloadStreamer
            });
            return bind1(Fusion_Impl_AppM.runAppM(velocityUI1(sdkAff)(engineInterfaceV2)(rawOptions)(function (v) {
                if (v instanceof Data_Either.Right) {
                    return liftAff(emit(new Fusion_Data_ObservableEvent.OnNext(v.value0)));
                };
                if (v instanceof Data_Either.Left) {
                    return liftAff(emit(new Fusion_Data_ObservableEvent.OnError(v.value0)));
                };
                throw new Error("Failed pattern match at Fusion.Entrypoint.VelocityUI (line 91, column 9 - line 93, column 61): " + [ v.constructor.name ]);
            })))(function () {
                return emit(Fusion_Data_ObservableEvent.OnComplete.value);
            });
        });
    };
};

// the type of this function must be synced with packages/fusion/src/Entrypoint/VelocityUI.d.ts
var speedtest = /* #__PURE__ */ Data_Function_Uncurried.mkFn2(speedtestCurried);
export {
    loadOutputDecodeJson,
    mkChartPropsDownload,
    speedtest,
    standaloneChartHandle,
    updateLoadResultDownload
};
export {
    initialLoadResult
} from "../Visonum.Cross.Components.App.Types.AppState/index.js";
